import { createApp } from 'vue';
import HeroSlider from './HeroSlider.vue';

// mount selector
const moduleSelector = '.hero-splide';

// Load real data from the DOM
const dataSection = document.querySelector(moduleSelector);

let dataSlides = [];
if (dataSection && dataSection.data) {
  try {
    const slidesData = JSON.parse(dataSection.data || '[]');
    dataSlides = slidesData?.data || [];
  } catch (e) {
    console.error('Failed to parse hero slider data:', e);
  }
}

// Assign unique id to each slide if not present
const slidesWithIds = dataSlides.map((slide, idx) => ({
  ...slide,
  id: slide.id || idx + 1,
}));

/**
 * Vue.js Init
 */
(() => {
  const module = document.querySelector(moduleSelector);
  if (!module) return;

  try {
    // vue components init
    createApp(HeroSlider, { slides: slidesWithIds }).mount(moduleSelector);
  } catch (error) {
    console.error(`Error: ${moduleSelector}`, error);
  }
})();
